/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import React, { Component } from 'react';
import IsoImage from 'images/footer/iso27001_blue.png';
import Logo from 'components/Logo';
import './index.scss';

import seeBusinessBetterImage from 'public/images/vpSeeBusinessBetter.svg?url';

export default class ErrorLayout extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`errorLayout ${this.props.className}`}>
        <div className="container">
          <div className="header">
            <div className="content">
              <Logo />
            </div>
          </div>

          <div className="body">
            <div className="content">
              {this.props.children}
            </div>
          </div>

          <div className="footer">
            <div className="content">

              <ul className="footer-nav">
                <li><strong><a href="https://www.viewpost.com">Viewpost.com</a></strong></li>
                <li><a href="https://www.viewpost.com/about-us">About Us</a></li>
                <li><a href="/terms">Terms</a></li>
                <li><a href="/privacy">Privacy</a></li>
                <li><a href="https://www.viewpost.com/security">Security</a></li>
                <li><a href="/contact/">Contact</a></li>
              </ul>
              <p className="copyright">Copyright &copy; {new Date().getFullYear()}. Viewpost IP Holdings, LLC. All Rights Reserved.</p>

              <div className="seals">
                <div id="isoSeal" className="seal iso">
                  <img src={IsoImage} />
                </div>
              </div>

            </div>
          </div>
          <div className="sub-footer">
            <div className="content">
              <a href="https://www.viewpost.com">
                <img src={seeBusinessBetterImage}/>
              </a>
            </div>
          </div>

        </div>
      </div>
    );
  }
}
